import {Directive, OnInit} from '@angular/core';
import { NzSelectComponent } from 'ng-zorro-antd/select';

@Directive({
  selector: '[appendToSelect]'
})
export class CsSelectUpdatePositionDirective implements OnInit{

  constructor(
    private select: NzSelectComponent
  ) { }

  ngOnInit(): void {
    this.select.nzOpenChange.subscribe(value=>{
      if(value){
        window.addEventListener('scroll',this.updatePosition,true);
      }else{
        window.removeEventListener('scroll',this.updatePosition,true);
      }
    })
  }

  updatePosition =(e:any)=>{
    if(this.select?.nzOpen){
      this.select?.updateCdkConnectedOverlayPositions();
    }
  }
}
